/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FitAndProperCheckReasonDetailViewModel
 */
export interface FitAndProperCheckReasonDetailViewModel {
    /**
     * 
     * @type {number}
     * @memberof FitAndProperCheckReasonDetailViewModel
     */
    reason?: number;
    /**
     * 
     * @type {string}
     * @memberof FitAndProperCheckReasonDetailViewModel
     */
    shortCode?: string;
    /**
     * 
     * @type {string}
     * @memberof FitAndProperCheckReasonDetailViewModel
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof FitAndProperCheckReasonDetailViewModel
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FitAndProperCheckReasonDetailViewModel
     */
    overridden?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FitAndProperCheckReasonDetailViewModel
     */
    subReasonDescription?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FitAndProperCheckReasonDetailViewModel
     */
    subReasonDescriptions?: Array<string>;
}

/**
 * Check if a given object implements the FitAndProperCheckReasonDetailViewModel interface.
 */
export function instanceOfFitAndProperCheckReasonDetailViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FitAndProperCheckReasonDetailViewModelFromJSON(json: any): FitAndProperCheckReasonDetailViewModel {
    return FitAndProperCheckReasonDetailViewModelFromJSONTyped(json, false);
}

export function FitAndProperCheckReasonDetailViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FitAndProperCheckReasonDetailViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'reason': !exists(json, 'Reason') ? undefined : json['Reason'],
        'shortCode': !exists(json, 'ShortCode') ? undefined : json['ShortCode'],
        'code': !exists(json, 'Code') ? undefined : json['Code'],
        'description': !exists(json, 'Description') ? undefined : json['Description'],
        'overridden': !exists(json, 'Overridden') ? undefined : json['Overridden'],
        'subReasonDescription': !exists(json, 'SubReasonDescription') ? undefined : json['SubReasonDescription'],
        'subReasonDescriptions': !exists(json, 'SubReasonDescriptions') ? undefined : json['SubReasonDescriptions'],
    };
}

export function FitAndProperCheckReasonDetailViewModelToJSON(value?: FitAndProperCheckReasonDetailViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Reason': value.reason,
        'ShortCode': value.shortCode,
        'Code': value.code,
        'Description': value.description,
        'Overridden': value.overridden,
        'SubReasonDescription': value.subReasonDescription,
        'SubReasonDescriptions': value.subReasonDescriptions,
    };
}

